import { TOKEN_INFO, ENTERPRISE_INFO, USER_ENTERPRISE_INFO, TOKEN_TIME, REVIEW_RESULT } from '@/param/method_param';
import { getStorage, saveStorage, removeStorage } from '@/utils/localStoreUtil';
import { reqUserEnterprise } from '@/api/userAPI';
import { errorNotify } from '@/utils/messageUtil';

const enterpriseInfo = {
  entName: '',
  regDate: '',
  uniteCode: '',
  corporate: '',
  regProvince: '',
  provinceCode: '',
  regCity: '',
  cityCode: '',
  regDistrict: '',
  districtCode: '',
  industry: '',
  regAddress: '',
  contactName: '',
  contactMobile: '',
}

const uniteCode = '91510000765096243X'

const personOptions = {
  namespaced: true,
  state: {
    tokenInfo: getStorage(TOKEN_INFO) || {},
    tokenTime: getStorage(TOKEN_TIME) || 0,
    enterpriseInfo: getStorage(ENTERPRISE_INFO) || enterpriseInfo,
    userEnterpriseInfo: getStorage(USER_ENTERPRISE_INFO) || {},
    reviewResult: getStorage(REVIEW_RESULT) || {},
  },
  mutations: {
    SET_TOKEN_INFO(state, value) {
      state.tokenInfo = value;
    },
    SET_TOKEN_TIME(state, value) {
      state.tokenTime = value;
    },
    SET_USER_ENTERPRISE_INFO(state, value) {
      state.userEnterpriseInfo = value;
    },
    SET_ENTERPRISE_INFO(state, value) {
      saveStorage(ENTERPRISE_INFO, value);
      state.enterpriseInfo = value;
    },
    SET_REVIEW_RESULT(state, value) {
      saveStorage(REVIEW_RESULT, value);
      state.reviewResult = value;
    },
    SET_RESET_STATE(state, _) {
      state.tokenInfo = {};
      state.tokenTime = 0;
      state.enterpriseInfo = enterpriseInfo;
      state.userEnterpriseInfo = {};
      state.reviewResult = {};
    },
  },
  actions: {
    // 用户TOKEN信息
    setTokenInfo(context, value) {
      saveStorage(TOKEN_INFO, value);
      const tokenTime = new Date().getTime();
      saveStorage(TOKEN_TIME, tokenTime);
      context.commit("SET_TOKEN_INFO", value);
      context.commit("SET_TOKEN_TIME", tokenTime);
    },
    // 用户企业数据
    async getUserEnterprise(context, that) {
      const resp = await reqUserEnterprise();
      if (resp.result) {
        saveStorage(USER_ENTERPRISE_INFO, resp.data);
        context.commit('SET_USER_ENTERPRISE_INFO', resp.data);
      } else {
        errorNotify(that, resp.message);
      }
    },
    setUserEnterprise(context, value) {
      saveStorage(USER_ENTERPRISE_INFO, value);
      context.commit('SET_USER_ENTERPRISE_INFO', value);
    },
    setResetState(context, _) {
			removeStorage(TOKEN_INFO);
			removeStorage(TOKEN_TIME);
			removeStorage(ENTERPRISE_INFO);
			removeStorage(USER_ENTERPRISE_INFO);
			removeStorage(REVIEW_RESULT);
			context.commit('SET_RESET_STATE');
		},
  },
  getters: {
    _isLogin(state) {
      return state.tokenInfo.access_token ? true : false;
    },
    _enterpriseDisable(state) {
      if (state.userEnterpriseInfo.id && state.userEnterpriseInfo.uniteCode !== uniteCode) {
        return true;
      } else {
        return false
      }
    }
  }
}

export default personOptions;
